import { useEffect, useRef, useState } from 'react';
import { useClube } from '../../contextClube';
import { Header } from '../Header';
import { FaCloudUploadAlt } from 'react-icons/fa'
import { InputCheck } from '../../../../../Forms/InputCheck';
import { InputGeneric } from '../../../../../Forms/InputGeneric';
import { api } from '../../../../../../services/api';
import { DotTypingLoader } from '../../../../../loaders/dotTypingLoader'
import { Button } from '../../../../../Button'
import { toast } from 'react-toastify';
import S3 from 'react-aws-s3';
import moment from 'moment';

import { Container, Content, Form, ImageUploader } from './style';
import { InputDate } from '../../../../../Forms/InputDate';


const config = {
    bucketName: 'portal.inoveclube',
    region: 'sa-east-1',
    dirName: '',
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
}



export function ModalFormsGeneric() {
    const { 
            modalFormsGenericIsOpen, 
            modalTitleAndRoute, 
            setModalFormsGenericIsOpen,
            datasToEdit, 
            setDatasToEdit,
            verifyingCreateSetter, updateSetter
    } = useClube()

    const [title, setTitle] = useState('')
    const [link, setLink] = useState('')
    const [initDate, setInitDate] = useState('')
    const [lastDate, setLastDate] = useState('')
    const [inputCheck, setInputCheck] = useState(false)
    const [img, setImg] = useState(null)

    const [imgName, setImgName] = useState('')
    const [imgFile, setImgFile] = useState(null)

    const inputFileRef = useRef(null)
    const [loading, setLoading] = useState(false)

    const ReactS3Client = new S3(config);
    const newFileName = moment(new Date()).format('DD-MM-YYYY') + imgName

    function handleCheckInput() {
        setInputCheck(!inputCheck)
    }
    
    function handleChooseFile() {
        inputFileRef.current.click()
    }

    function clearImg() {
        setImg(null)
        setImgName('')
        inputFileRef.current.value = ''
    }

    function convertImg(file) {
        setImgFile(file)
        if(file){
          const reader = new FileReader()
          reader.onload = function() {
            setImg(reader.result)
          }
          reader.readAsDataURL(file)
          setImgName(file.name)
        }
    }

    function checkFileType(file) {
        let ext = file.value.match(/\.(.+)$/)[1];
        //console.log(file.value.match(/\.(.+)$/))
        let fileNameLength = file.files[0].name.split('').length

        if(fileNameLength > 30){
            toast.warning('⚠️ O nome da imagem deve conter até 30 caracteres')
            inputFileRef.current.value = ''
            return
        }

        switch (ext) {
            case 'jpg':
            case 'jpeg':
            case 'png':
                convertImg(file.files[0])
                break
            default:
                toast.warning('⚠️ Tipo de arquivo não aceito')
                inputFileRef.current.value = ''
        }
    }

    function dateSanitation (date){
        const dateSplit = new Date(date).toLocaleDateString('pt-BR', {timeZone: 'UTC'}).split('')
        return `${dateSplit[6] + dateSplit[7] + dateSplit[8] 
            + dateSplit[9] + '-' + dateSplit[3] 
            + dateSplit[4] + '-' + dateSplit[0] + dateSplit[1]}` 
    }

    async function postPublication(location) {
        const obj = {
            title,
            link,
            initDate,
            lastDate,
            active: true,
            deadline: !inputCheck,
            image: location,
            imageName: imgName,
        }
       
        try{
            if(title === '' || link === '' || initDate === '')
                throw new Error('Preencha todos os campos')

            if(inputCheck === false && lastDate === '')
                throw new Error('Publicação com prazo precisa de data de expiração')
           
            const response = await api.post(`${modalTitleAndRoute.route}`, obj,  {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        
            const { success, message, objectCreated } = response.data
        
            if(success){
                verifyingCreateSetter(modalTitleAndRoute.route, objectCreated)
                setModalFormsGenericIsOpen(false)
                toast.success(message)
            }
            else
                toast.error(message)

            setLoading(false)
        }catch(error){
            setLoading(false)
            toast.error(error.message)
            toast.error(error)
        }
    }

    async function updatePublication(location) {
        const obj = {
            id: datasToEdit.id,
            title,
            link,
            initDate,
            lastDate,
            active: true,
            deadline: !inputCheck,
            image: location,
            imageName: imgName,
        }
       
        try{
            if(title === '' || link === '' || initDate === '')
                throw new Error('Preencha todos os campos')

            if(inputCheck === false && lastDate === '')
                throw new Error('Publicação com prazo precisa de data de expiração')
           
            const response = await api.put(`${modalTitleAndRoute.route}`, obj,  {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        
            const { success, message } = response.data
        
            if(success){
                updateSetter(modalTitleAndRoute.route, obj)
                setModalFormsGenericIsOpen(false)
                toast.success(message)
            }
            else
                toast.error(message)

            setLoading(false)
        }catch(error){
            setLoading(false)
            toast.error(error.message)
            toast.error(error)
        }
    }


    function handleSaveS3Image() {
        if(img === null){
            toast.error('Selecione uma imagem')
            return
        } 
        if(img !== null && img.slice(0, 8) === 'https://'){
            updatePublication(img)
            setLoading(true)
            return
        }

        setLoading(true)
        ReactS3Client
            .uploadFile(imgFile, newFileName)
            .then((data) => {
                modalTitleAndRoute.create === 1 ? postPublication(data.location) : updatePublication(data.location)
            })
            .catch(err => {
                toast.error('Erro de envio de imagem')
                setLoading(false)
            })
    } 

    
    useEffect(() => {
        if(datasToEdit !== null){
            setTitle(datasToEdit.title)
            setLink(datasToEdit.link)
            setInitDate(dateSanitation(datasToEdit.initDate))
            setLastDate(datasToEdit.lastDate === null ? '' : dateSanitation(datasToEdit.lastDate))
            setInputCheck(!datasToEdit.deadline)
            setImg(datasToEdit.image)
            setImgName(datasToEdit.imageName)
        }
    }, [datasToEdit])

    useEffect(() => {
        if(modalFormsGenericIsOpen === false){
            setTitle('')
            setLink('')
            setInitDate('')
            setLastDate('')
            setInputCheck(false)
            setImg(null)
            setDatasToEdit(null)
            setImgName('')
            setImgFile(null)
            inputFileRef.current.value = ''
        }
    }, [modalFormsGenericIsOpen, setDatasToEdit])

    useEffect(() => {
        if(inputCheck)
            setLastDate('')
    }, [inputCheck])

  

    return(
        <Container modalFormsGenericIsOpen={modalFormsGenericIsOpen}>
            <Content>
                <Header 
                    title={modalTitleAndRoute.title}
                    setModalFormsIsOpen={setModalFormsGenericIsOpen}
                />

                <Form>
                    <div className="normalInput">
                        <InputGeneric
                            type="text"
                            placeholder="Título"
                            color="#7A05A7"
                            value={title}
                            max={50}
                            onChange={event => setTitle(event.target.value)}
                        />

                        <InputGeneric 
                            type="text"
                            placeholder="Link"
                            color="#7A05A7"
                            value={link}
                            max={100}
                            onChange={event => setLink(event.target.value)}
                        />
                    </div>

                    <div className="dateInputs">
                        <InputDate
                            type="date"
                            value={initDate}
                            onChange={event => setInitDate(event.target.value)}
                        />
                        <p>a</p>
                        <InputDate 
                            type="date"
                            active={!inputCheck}
                            value={lastDate}
                            onChange={event => setLastDate(event.target.value)}
                        />
                    </div>

                    <div className="inputText">
                        <InputCheck 
                            handleClick={handleCheckInput}
                            checked={inputCheck}
                        />
                        <p>Sem prazo</p>
                    </div>
                    
                    <ImageUploader img={img}>
                        <div className="imageArea">
                                <span 
                                    className="closeButton"
                                    onClick={clearImg}
                                >
                                    &#10006;
                                </span>
                                
                                {
                                    img === null ?
                                    <>
                                        <FaCloudUploadAlt />
                                        <p>Sem imagem</p>
                                    </>
                                    :<></>
                                }

                                <div className="fileName">
                                    <span>{imgName}</span>
                                </div>

                            
                                <img src={img} alt="imageFile"/> 
                        </div>

                        <button onClick={handleChooseFile}>
                            Upload
                        </button>

                        <input 
                            type="file"
                            accept="image"
                            ref={inputFileRef}
                            onChange={event => checkFileType(event.target)}
                            hidden
                        />
                    </ImageUploader>
            
                </Form>

                <Button 
                    background="#7A05A7"
                    color="#FFF"
                    onClick={handleSaveS3Image}
                >
                    {loading ?
                    <DotTypingLoader />
                        :
                    'Publicar'
                    }
                </Button>
            </Content>
        </Container>
    )
}
